<div class="out">
  <div class="round"  kzLib (click)="openApptsWnd($event)" [ngClass]="{opened:bShowCallsWnd}">
    <img class="abs_center" src="assets/images/scheduling.svg" alt="">
  </div>

</div>
